/** Matches relaxed Supabase password policy (upper + lower + digit). */
export const PASSWORD_POLICY_HINT =
  "Passwords must have at least one capital, one lowercase letter, and one number.";

export function formatAuthPasswordError(raw: string | null | undefined): string {
  const s = (raw ?? "").trim();
  if (!s) return PASSWORD_POLICY_HINT;
  const lower = s.toLowerCase();
  if (
    lower.includes("at least one character of each") ||
    lower.includes("password should contain") ||
    /one character of each:/i.test(s)
  ) {
    return PASSWORD_POLICY_HINT;
  }
  return s;
}

export function passwordMeetsRelaxedPolicy(pw: string, minLen = 8): boolean {
  if (pw.length < minLen) return false;
  return /[a-z]/.test(pw) && /[A-Z]/.test(pw) && /\d/.test(pw);
}
